module.exports = __webpack_public_path__ + "img/64ne.89a5ac1d.svg";